import { helpers } from 'vuelidate/lib/validators';

export const validAreaCalculationFormula = function (value) {
    if (!helpers.req(value)) {
        return true;
    }

    const formula = value;
    const regex = /^(?:\s*[\d+\-*/()]|\s*\{\d+\}\s*)+$/;

    return regex.test(formula);
};
